import { render, staticRenderFns } from "./shelvesGoods.vue?vue&type=template&id=13ab5802&scoped=true&"
import script from "./shelvesGoods.vue?vue&type=script&lang=js&"
export * from "./shelvesGoods.vue?vue&type=script&lang=js&"
import style0 from "./shelvesGoods.vue?vue&type=style&index=0&id=13ab5802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab5802",
  null
  
)

export default component.exports